import { KYCServiceType } from "consts/kyc";
import type { ID } from "types";
import { route } from "util/support";

export const enum ApiRouteTypes {
  GetTransactionFilters = 'GetTransactionFilters',
  GetBankSdk = 'GetBankSdk',
  GetToken = 'GetToken',
  GetTransactionById = 'GetTransactionById',
  GetTransactionHistory = 'GetTransactionHistory',
  GetSendExport = 'GetSendExport',
  GetClearExport = 'GetClearExport',
  GetDownloadCSV = 'GetDownloadCSV',
  GetTransactionOrigins = 'GetTransactionOrigins',
  // New API
  // General
  GetConstants = 'GetConstants',
  GetCountries = 'GetCountries',
  GetUsersPreferences = 'GetUsersPreferences',
  PutUsersPreferences = 'PutUsersPreferences',
  // Files
  GetFile = 'GetFile',
  GetLocalFile = 'GetLocalFile',
  PostFile = 'PostFile',
  DeleteFile = 'DeleteFile',
  // Authentication
  PostLogin = 'PostLogin',
  PostRefreshToken = 'PostRefreshToken',
  PostLogout = 'PostLogout',
  // 2FA
  PostVerify2FA = 'PostVerify2FA',
  PostResend2FACode = 'PostResend2FACode',
  // Forgot password
  PostRecover = 'PostRecover',
  PostNewPassword = 'PostNewPassword',
  // Transactions
  GetTransactions = 'GetTransactions',
  GetEsTransactions = 'GetEsTransactions',
  PingTransactions = 'PingTransactions',
  // Notifications
  GetInNotifications = 'GetInNotifications',
  GetOutNotifications = 'GetOutNotifications',
  // Notiication channels
  GetNotificationChannels = 'GetNotificationChannels',
  // Merchants
  GetMerchants = 'GetMerchants',
  GetMerchant = 'GetMerchant',
  GetMerchantUsers = 'GetMerchantUsers',
  GetMerchantByIdUsers = 'GetMerchantByIdUsers',
  PostMerchant = 'PostMerchant',
  PutMerchant = 'PutMerchant',
  GetMerchantGroups = 'GetMerchantGroups',
  PostMerchantsGroupsPivot = 'PostMerchantsGroupsPivot',
  DeleteMerchantsGroupsPivot = 'DeleteMerchantsGroupsPivot',
  GetMerchantSettings = 'GetMerchantSettings',
  PutMerchantSettings = 'PutMerchantSettings',
  GetMerchantKYCSettings = 'GetMerchantKYCSettings',
  PutMerchantKYCSettings = 'PutMerchantKYCSettings',
  GetPspKycSettings = 'GetPspKycSettings',
  GetPspKycSetting = 'GetPspKycSetting',
  PostPspKycSetting = 'PostPspKycSetting',
  DeletePspKycSetting = 'DeletePspKycSetting',
  GetPayoutAccounts = 'GetPayoutAccounts',
  PutPayoutAccounts = 'PutPayoutAccounts',
  DeletePayoutAccounts = 'DeletePayoutAccounts',
  GetPayoutCryptoAccounts = 'GetPayoutCryptoAccounts',
  PutPayoutCryptoAccounts = 'PutPayoutCryptoAccounts',
  DeletePayoutCryptoAccounts = 'DeletePayoutCryptoAccounts',
  GetMerchantDomains = 'GetMerchantDomains',
  DeleteMerchantDomains = 'DeleteMerchantDomains',
  PostMerchantDomains = 'PostMerchantDomains',
  GetMerchantBusinesses = 'GetMerchantBusinesses',
  DeleteMerchantBusinesses = 'DeleteMerchantBusinesses',
  PostMerchantBusinesses = 'PostMerchantBusinesses',
  // Ledgers
  GetLedgers = 'GetLedgers',
  PostLedgers = 'PostLedgers',
  PutLedgers = 'PutLedgers',
  // Merchant pivots
  GetMerchantsNotificationChannelsPivot = 'GetMerchantsNotificationChannelsPivot',
  PutMerchantsNotificationChannelsPivot = 'PutMerchantsNotificationChannelsPivot',
  // Consumers
  GetConsumers = 'GetConsumers',
  PostConsumer = 'PostConsumer',
  GetConsumersBlacklist = 'GetConsumersBlacklist',
  PostConsumersBlacklist = 'PostConsumersBlacklist',
  DeleteConsumersBlacklist = 'DeleteConsumersBlacklist',
  GetImportConsumerBlacklist = 'GetImportConsumerBlacklist',
  PostImportConsumerBlacklist = 'PostImportConsumerBlacklist',
  GetConsumersWhitelist = 'GetConsumersWhitelist',
  PostConsumersWhitelist = 'PostConsumersWhitelist',
  PostImportConsumerWhitelist = 'PostImportConsumerWhitelist',
  GetTemplateEmailsWhitelist = 'GetTemplateEmailsWhitelist',
  GetTemplateEmailsWhitelistWithoutSdd = 'GetTemplateEmailsWhitelistWithoutSdd',
  GetConsumerByEmailOrId = 'GetConsumerByEmailOrId',
  PutConsumer = 'PutConsumer',
  GetConsumerEmails = 'GetConsumerEmails',
  PutConsumerEmails = 'PutConsumerEmails',
  GetConsumersKYCSettings = 'GetConsumersKYCSettings',
  PostConsumersKYCSettings = 'PostConsumersKYCSettings',
  GetConsumersManualBulkKYCsImportHistoryPivot = 'GetConsumersManualBulkKYCsImportHistoryPivot',
  // Payment methods
  GetPaymentMethods = 'GetPaymentMethods',
  PostPaymentMethods = 'PostPaymentMethods',
  // Setups
  GetSetups = 'GetSetups',
  PutSetups = 'PutSetups',
  DeleteSetup = 'DeleteSetup',
  PostSetupGroupPivot = 'PostSetupGroupPivot',
  // Users
  GetUsers = 'GetUsers',
  PostUser = 'PostUser',
  GetRoles = 'GetRoles',
  DeleteUser = 'DeleteUser',
  // User pivots
  GetUsersMerchants = 'GetUsersMerchants',
  PostUserMerchant = 'PostUserMerchant',
  DeleteUserMerchant = 'DeleteUserMerchant',
  GetUsersMors = 'GetUsersMors',
  PostUserMor = 'PostUserMor',
  DeleteUserMor = 'DeleteUserMor',
  // Merchant Payouts
  GetEsMerchantPayoutFiles = 'GetEsMerchantPayoutFiles',
  GetMerchantPayoutSummaryFiles = 'GetMerchantPayoutSummaryFiles',
  GetMerchantPayoutFiles = 'GetMerchantPayoutFiles',
  GetMerchantPayoutFilesById = 'GetMerchantPayoutFilesById',
  GetMerchantPayoutCalculations = 'GetMerchantPayoutCalculations',
  GetMerchantPayoutFileTaxCalculations = 'GetMerchantPayoutFileTaxCalculations',
  PostMerchantPayoutFileTaxCalculations = 'PostMerchantPayoutFileTaxCalculations',
  DeleteMerchantPayoutFileTaxCalculations = 'DeleteMerchantPayoutFileTaxCalculations',
  GetTransactionsMerchantPayoutIncrementsPivot = 'GetTransactionsMerchantPayoutIncrementsPivot',
  GetMerchantPayoutIncrementTaxes = 'GetMerchantPayoutIncrementTaxes',
  PostMerchantPayoutIncrementTaxes = 'PostMerchantPayoutIncrementTaxes',
  PutMerchantPayoutIncrementTaxes = 'PutMerchantPayoutIncrementTaxes',
  DeleteMerchantPayoutIncrementTaxes = "DeleteMerchantPayoutIncrementTaxes",
  GetMerchantPayoutIncrements = 'GetMerchantPayoutIncrements',
  PutMerchantPayoutIncrements = 'PutMerchantPayoutIncrements',
  PostMerchantPayoutIncrementTaxesBulk = 'PostMerchantPayoutIncrementTaxesBulk',
  GetMerchantPayoutIncrementExchangeRates = 'GetMerchantPayoutIncrementExchangeRates',
  PostMerchantPayoutIncrementExchangeRates = 'PostMerchantPayoutIncrementExchangeRates',
  DeleteMerchantPayoutIncrementExchangeRates = 'DeleteMerchantPayoutIncrementExchangeRates',
  PostMerchantPayoutIncrementExchangeRatesBulk = 'PostMerchantPayoutIncrementExchangeRatesBulk',
  PostMerchantPayoutFiles = 'PostMerchantPayoutFiles',
  PutMerchantPayoutFiles = 'PutMerchantPayoutFiles',
  PreviewMerchantPayoutFilesSettlementXLS = 'PreviewMerchantPayoutFilesSettlementXLS',
  GetMerchantPayoutFilesTransactionsCSV = 'GetMerchantPayoutFilesTransactionsCSV',
  GetMerchantPayoutSummaryFilesTransactionsCSV = 'GetMerchantPayoutSummaryFilesTransactionsCSV',
  GetMerchantPayoutFilesStillPendingSettlementCSV = 'GetMerchantPayoutFilesStillPendingSettlementCSV',
  DeleteMerchantPayoutFiles = "DeleteMerchantPayoutFiles",
  PostMerchantPayoutSummaryFiles = 'PostMerchantPayoutSummaryFiles',
  DeleteMerchantPayoutSummaryFiles = 'DeleteMerchantPayoutSummaryFiles',
  GetMerchantsMethodsPivot = 'GetMerchantsMethodsPivot',
  PostMerchantsMethodsPivot = 'PostMerchantsMethodsPivot',
  PutMerchantsMethodsPivot = 'PutMerchantsMethodsPivot',
  GetMerchantsMethodsPivotHistory = 'GetMerchantsMethodsPivotHistory',
  GetSettlementsImportHistory = 'GetSettlementsImportHistory',
  PostPspSettlements = 'PostPspSettlements',
  // KYCs
  GetKycs = 'GetKycs',
  PostKycs = 'PostKycs',
  DeleteKYCs = 'DeleteKYCs',
  PostManualBulkKYCsImportHistory = 'PostManualBulkKYCsImportHistory',
  // Manual Bulk KYCs Import History
  GetManualBulkKYCsImportHistory = 'GetManualBulkKYCsImportHistory',
  // KYC Settings
  GetKYCSettings = 'GetKYCSettings',
  PostKYCSettings = 'PostKYCSettings',
  GetBitsoBanks = 'GetBitsoBanks',
  // Open Banking
  GetBankingSdkConnectors = 'GetBankingSdkConnectors',
  PutBankingSdkConnectors = 'PutBankingSdkConnectors',
  GetIbanXsBanks = 'GetIbanXsBanks',
  PutIbanXsBanks = 'PutIbanXsBanks',
  GetBankingSdkRecipients = 'GetBankingSdkRecipients',
  PostBankingSdkRecipients = 'PostBankingSdkRecipients',
  PutBankingSdkRecipients = 'PutBankingSdkRecipients',
  DeleteBankingSdkRecipients = 'DeleteBankingSdkRecipients',
  GetBankingSdkConnectorsRecipientsPivot = 'GetBankingSdkConnectorsRecipientsPivot',
  PostBankingSdkConnectorsRecipientsPivot = 'PostBankingSdkConnectorsRecipientsPivot',
  PutBankingSdkConnectorsRecipientsPivot = 'PutBankingSdkConnectorsRecipientsPivot',
  DeleteBankingSdkConnectorsRecipientsPivot = 'DeleteBankingSdkConnectorsRecipientsPivot',
  GetIbanXsBanksRecipientsPivot = 'GetIbanXsBanksRecipientsPivot',
  PostIbanXsBanksRecipientsPivot = 'PostIbanXsBanksRecipientsPivot',
  PutIbanXsBanksRecipientsPivot = 'PutIbanXsBanksRecipientsPivot',
  DeleteIbanXsBanksRecipientsPivot = 'DeleteIbanXsBanksRecipientsPivot',
  GetIbanXsBanksCountriesPivot = 'GetIbanXsBanksCountriesPivot',
  PostIbanXsBanksCountriesPivot = 'PostIbanXsBanksCountriesPivot',
  PutIbanXsBanksCountriesPivot = 'PutIbanXsBanksCountriesPivot',
  DeleteIbanXsBanksCountriesPivot = 'DeleteIbanXsBanksCountriesPivot',
  GetTransactionsOpXHeadersHistory = 'GetTransactionsOpXHeadersHistory',
  // Onboarding
  GetApplications = 'GetApplications',
  PutApplications = 'PutApplications',
  PatchApplications = 'PatchApplications',
  DeleteApplications = 'DeleteApplications',
  GetOnboardingLogs = 'GetOnboardingLogs',
  // WhatsApp Messaging
  GetWaMessages = 'GetWaMessages',
  GetWaMessagesSetups = 'GetWaMessagesSetups',
  PostWaMessagesSetups = 'PostWaMessagesSetups',
  PutWaMessagesSetups = 'PutWaMessagesSetups',
  DeleteWaMessagesSetups = 'DeleteWaMessagesSetups',
  GetPhoneVerifications = 'GetPhoneVerifications',
  GetFailedPhoneVerifications = 'GetFailedPhoneVerifications',
  GetWaTemplatesSetups = 'GetWaTemplatesSetups',
  PostWaTemplatesSetups = 'PostWaTemplatesSetups',
  PutWaTemplatesSetups = 'PutWaTemplatesSetups',
  DeleteWaTemplatesSetups = 'DeleteWaTemplatesSetups',
  GetECommerceBusinessInformationSteps = 'GetECommerceBusinessInformationSteps',
  PutECommerceBusinessInformationSteps = 'PutECommerceBusinessInformationSteps',
  GetECommerceBillingFinanceSteps = 'GetECommerceBillingFinanceSteps',
  PutECommerceBillingFinanceSteps = 'PutECommerceBillingFinanceSteps',
  GetECommerceMediaComplianceSteps = 'GetECommerceMediaComplianceSteps',
  PutECommerceMediaComplianceSteps = 'PutECommerceMediaComplianceSteps',
  GetECommerceIdentityVerificationSteps = 'GetECommerceIdentityVerificationSteps',
  PutECommerceIdentityVerificationSteps = 'PutECommerceIdentityVerificationSteps',
  GetECommercePaymentMethodsSteps = 'GetECommercePaymentMethodsSteps',
  PutECommercePaymentMethodsSteps = 'PutECommercePaymentMethodsSteps',
  PutECommerceUboIdentities = 'PutECommerceUboIdentities',
};

export const ApiRoutes = {
  [ApiRouteTypes.GetTransactionFilters]: '/getTransactionFilters',
  [ApiRouteTypes.GetBankSdk]: (queryString: string) => `/getBankSdk${queryString}`,
  [ApiRouteTypes.GetToken]: '/getToken',
  [ApiRouteTypes.GetTransactionById]: (transactionId: ID) => `/getTransaction/${transactionId}`,
  [ApiRouteTypes.GetSendExport]: (queryString: string) => `/sendExport${queryString}`,
  [ApiRouteTypes.GetClearExport]: '/clearExport',
  [ApiRouteTypes.GetDownloadCSV]: '/downloadCsv',
  [ApiRouteTypes.GetTransactionOrigins]: '/transaction-origins',
  [ApiRouteTypes.GetConsumers]: '/consumers',
  [ApiRouteTypes.PostConsumer]: '/consumers',
  [ApiRouteTypes.GetConsumersBlacklist]: '/consumers-blacklist',
  [ApiRouteTypes.PostConsumersBlacklist]: '/consumers-blacklist',
  [ApiRouteTypes.DeleteConsumersBlacklist]: (coreIdOrEmail: ID) =>
    route(['consumers-blacklist', coreIdOrEmail]),
  [ApiRouteTypes.PostConsumersWhitelist]: '/consumers-whitelist',
  [ApiRouteTypes.GetConsumersWhitelist]: '/consumers-import-history',
  [ApiRouteTypes.GetConsumerEmails]: route(['consumer-emails']),
  [ApiRouteTypes.PutConsumerEmails]: (coreId: ID) =>
    route(['consumer-emails', coreId]),
  [ApiRouteTypes.GetConsumerByEmailOrId]: (emailOrId: ID) =>
    route(['consumers', emailOrId]),
  [ApiRouteTypes.PostFile]: '/files',
  [ApiRouteTypes.GetFile]: (fileKey: string) =>
    route(['/files', fileKey]),
  [ApiRouteTypes.GetLocalFile]: (fileKey: string) =>
    route(['/localFiles', fileKey]),
  [ApiRouteTypes.DeleteFile]: (fileKey: string) =>
    route(['/files', fileKey]),
  [ApiRouteTypes.PutConsumer]: (coreIdOrEmail: ID) =>
    route(['consumers', coreIdOrEmail]),
  [ApiRouteTypes.GetPayoutAccounts]: '/payout-accounts',
  [ApiRouteTypes.PutPayoutAccounts]: (coreId?: ID) =>
    route(['payout-accounts', coreId]),
  [ApiRouteTypes.DeletePayoutAccounts]: (coreId: ID) =>
    route(['payout-accounts', coreId]),
  [ApiRouteTypes.GetPayoutCryptoAccounts]: '/payout-crypto-accounts',
  [ApiRouteTypes.PutPayoutCryptoAccounts]: (coreId?: ID) =>
    route(['payout-crypto-accounts', coreId]),
  [ApiRouteTypes.DeletePayoutCryptoAccounts]: (coreId: ID) =>
    route(['payout-crypto-accounts', coreId]),
  // [ApiRouteTypes.PostSaveUser]: '/saveUser',
  // [ApiRouteTypes.PostUpdateUser]: (userId: ID) => `/updateUser/${userId}`,
  // New API
  // [ApiRouteTypes.GetUser]: (userId: ID) => `/users/${userId}`,
  [ApiRouteTypes.PostLogin]: '/login',
  [ApiRouteTypes.PostRefreshToken]: '/refresh',
  [ApiRouteTypes.PostLogout]: '/logout',
  [ApiRouteTypes.GetConstants]: '/constants',
  [ApiRouteTypes.PingTransactions]: (coreId?: ID) =>
    route([`/ping-transactions`, coreId]),
  [ApiRouteTypes.GetTransactions]: (coreId?: ID) =>
    route([`/transactions`, coreId]),
  [ApiRouteTypes.GetEsTransactions]: '/es-transactions',
  [ApiRouteTypes.GetTransactionHistory]: '/transactions-history',
  [ApiRouteTypes.GetMerchants]: '/merchants',
  [ApiRouteTypes.GetMerchant]: (coreId: ID) => route(['merchants', coreId]),
  [ApiRouteTypes.GetMerchantUsers]: '/users',
  [ApiRouteTypes.GetMerchantByIdUsers]: route(['users']),
  [ApiRouteTypes.GetMerchantKYCSettings]: '/merchant-kyc-settings',
  [ApiRouteTypes.GetPspKycSettings]: '/psp-kyc-settings',
  [ApiRouteTypes.GetPspKycSetting]: (coreId: ID) =>
    route(['psp-kyc-settings', coreId]),
  [ApiRouteTypes.PostPspKycSetting]: '/psp-kyc-settings',
  [ApiRouteTypes.DeletePspKycSetting]: (coreId: ID) =>
    route(['psp-kyc-settings', coreId]),
  [ApiRouteTypes.GetLedgers]: route(['ledgers']),
  [ApiRouteTypes.PostLedgers]: (coreId?: ID) => route(['ledgers', coreId]),
  [ApiRouteTypes.PutLedgers]: (coreId: ID) => route(['ledgers', coreId]),
  [ApiRouteTypes.PutMerchantKYCSettings]: (
    merchantId: ID,
    kycTypeId: KYCServiceType
  ) => route(['merchant-kyc-settings', [merchantId, kycTypeId].join('_')]),
  [ApiRouteTypes.GetMerchantSettings]: '/merchant-settings',
  [ApiRouteTypes.PutMerchantSettings]: (coreId?: ID) =>
    route(['merchant-settings', coreId]),
  [ApiRouteTypes.GetMerchantsNotificationChannelsPivot]: '/merchants-notification-channels-pivot',
  [ApiRouteTypes.PutMerchantsNotificationChannelsPivot]: (
    merchantId: ID,
    notificationChannelId: ID
  ) =>
    route(['merchants-notification-channels-pivot', [merchantId, notificationChannelId].join('_')]),
  [ApiRouteTypes.GetConsumersKYCSettings]: '/consumer-kyc-settings',
  [ApiRouteTypes.PostConsumersKYCSettings]: '/consumer-kyc-settings',
  [ApiRouteTypes.GetKYCSettings]: '/kyc-settings',
  [ApiRouteTypes.PostKYCSettings]: (merchantId?: ID) => route(['kyc-settings', merchantId]),
  [ApiRouteTypes.PostMerchant]: (merchantId?: ID) => route(['/merchants', merchantId]),
  [ApiRouteTypes.PutMerchant]: (coreId: ID) => route(['merchants', coreId]),
  [ApiRouteTypes.GetMerchantGroups]: '/merchant-groups',
  [ApiRouteTypes.PostMerchantsGroupsPivot]: '/merchants-groups-pivot',
  [ApiRouteTypes.DeleteMerchantsGroupsPivot]: (coreId: ID) =>
    route(['/merchants-groups-pivot', coreId]),
  [ApiRouteTypes.GetPaymentMethods]: '/payment-methods',
  [ApiRouteTypes.PostPaymentMethods]: (coreId?: ID) => route(['/payment-methods', coreId]),
  [ApiRouteTypes.GetInNotifications]: '/notifications-in-history',
  [ApiRouteTypes.GetOutNotifications]: '/notifications-out-history',
  [ApiRouteTypes.GetNotificationChannels]: '/notification-channels',
  [ApiRouteTypes.GetCountries]: '/countries',
  [ApiRouteTypes.GetUsers]: (userId?: ID) => route(['/users', userId]),
  [ApiRouteTypes.DeleteUser]: (coreId?: ID) =>
  route(['/users', coreId]),
  [ApiRouteTypes.PostUser]: (userId?: ID) => route(['/users', userId]),
  [ApiRouteTypes.GetRoles]: '/roles',
  [ApiRouteTypes.GetUsersMerchants]: (userId?: ID) =>
    route(['/users-merchants-pivot', `?userId[in][]=${userId}`], ''),
  [ApiRouteTypes.GetUsersMors]: (userId?: ID) =>
    route(['/users-mors-pivot', `?userId[in][]=${userId}`], ''),
  [ApiRouteTypes.PostUserMerchant]: '/users-merchants-pivot',
  [ApiRouteTypes.DeleteUserMerchant]: (merchantId: ID, userId: ID) =>
    route(['/users-merchants-pivot', `${merchantId}_${userId}`]),
  [ApiRouteTypes.PostUserMor]: '/users-mors-pivot',
  [ApiRouteTypes.DeleteUserMor]: (MOR: string, userId: ID) =>
    route(['/users-mors-pivot', `${MOR}_${userId}`]),
  // Merchant Payouts
  [ApiRouteTypes.GetMerchantPayoutSummaryFiles]: '/merchant-payout-summary-files',
  [ApiRouteTypes.PostMerchantPayoutSummaryFiles]: '/merchant-payout-summary-files',
  [ApiRouteTypes.DeleteMerchantPayoutSummaryFiles]: (coreId: ID) =>
    route(['/merchant-payout-summary-files', coreId]),
  [ApiRouteTypes.GetEsMerchantPayoutFiles]: '/es-merchant-payout-files',
  [ApiRouteTypes.GetMerchantPayoutFiles]: '/merchant-payout-files',
  [ApiRouteTypes.GetMerchantPayoutFilesById]: (coreId: ID) =>
    route(['/merchant-payout-files', coreId]),
  [ApiRouteTypes.PostMerchantPayoutFiles]: "/merchant-payout-files",
  [ApiRouteTypes.PutMerchantPayoutFiles]: (coreId: ID) =>
    route(['merchant-payout-files', coreId]),
  [ApiRouteTypes.DeleteMerchantPayoutFiles]: (coreId?: ID) =>
    route(['/merchant-payout-files', coreId]),
  [ApiRouteTypes.GetMerchantPayoutCalculations]: '/merchant-payout-calculations',
  [ApiRouteTypes.GetMerchantPayoutFileTaxCalculations]: '/merchant-payout-file-tax-calculations',
  [ApiRouteTypes.PostMerchantPayoutFileTaxCalculations]: (coreId?: ID) =>
    route(['/merchant-payout-file-tax-calculations', coreId]),
  [ApiRouteTypes.DeleteMerchantPayoutFileTaxCalculations]: (coreId: ID) =>
    route(['/merchant-payout-file-tax-calculations', coreId]),
  [ApiRouteTypes.GetTransactionsMerchantPayoutIncrementsPivot]: '/transactions-merchant-payout-increments-pivot',
  [ApiRouteTypes.GetMerchantPayoutIncrementTaxes]: '/merchant-payout-increment-taxes',
  [ApiRouteTypes.PostMerchantPayoutIncrementTaxes]: '/merchant-payout-increment-taxes',
  [ApiRouteTypes.PutMerchantPayoutIncrementTaxes]: (coreId: ID) =>
    route(['/merchant-payout-increment-taxes', coreId]),
  [ApiRouteTypes.PostMerchantPayoutIncrementTaxesBulk]: '/import-merchant-payout-increment-taxes',
  [ApiRouteTypes.DeleteMerchantPayoutIncrementTaxes]: (coreId?: ID) =>
    route(['/merchant-payout-increment-taxes', coreId]),
  [ApiRouteTypes.GetMerchantPayoutIncrements]: '/merchant-payout-increments',
  [ApiRouteTypes.PutMerchantPayoutIncrements]: (coreId: ID) =>
    route(['/merchant-payout-increments', coreId]),
  [ApiRouteTypes.GetMerchantPayoutIncrementExchangeRates]: '/merchant-payout-increment-exchange-rates',
  [ApiRouteTypes.PostMerchantPayoutIncrementExchangeRates]: '/merchant-payout-increment-exchange-rates',
  [ApiRouteTypes.DeleteMerchantPayoutIncrementExchangeRates]: (coreId?: ID) =>
    route(['/merchant-payout-increment-exchange-rates', coreId]),
  [ApiRouteTypes.PostMerchantPayoutIncrementExchangeRatesBulk]: '/import-merchant-payout-increment-exchange-rates',
  [ApiRouteTypes.GetMerchantPayoutFilesTransactionsCSV]: (coreId?: ID) =>
    route(['/merchant-payout-file-csv-transactions', coreId]),
  [ApiRouteTypes.GetMerchantPayoutSummaryFilesTransactionsCSV]: (coreId?: ID) =>
    route(['/merchant-payout-summary-file-csv-transactions', coreId]),
  [ApiRouteTypes.GetMerchantPayoutFilesStillPendingSettlementCSV]: (coreId?: ID) =>
    route(['/merchant-payout-file-csv-pending-settlement-transactions', coreId]),
  [ApiRouteTypes.PreviewMerchantPayoutFilesSettlementXLS]: (coreId?: ID) =>
    route(['/settlement-sheet-merchant-payout-files', coreId]),
  [ApiRouteTypes.GetMerchantsMethodsPivot]: '/merchants-methods-pivot',
  [ApiRouteTypes.GetMerchantsMethodsPivotHistory]: '/merchants-methods-pivot-history',
  [ApiRouteTypes.PostMerchantsMethodsPivot]: route(['merchants-methods-pivot']),
  [ApiRouteTypes.PutMerchantsMethodsPivot]: (coreId: ID) =>
    route(['merchants-methods-pivot', coreId]),
  [ApiRouteTypes.GetSettlementsImportHistory]: '/settlements-import-history',
  [ApiRouteTypes.GetKycs]: '/kycs',
  [ApiRouteTypes.PostKycs]: '/kycs',
  [ApiRouteTypes.DeleteKYCs]: (pki: string) => route(['/kycs', pki]),
  [ApiRouteTypes.GetUsersPreferences]: (userId: ID) => route(['/users-preferences', userId]),
  [ApiRouteTypes.PutUsersPreferences]: (userId: ID) => route(['/users-preferences', userId]),
  [ApiRouteTypes.GetManualBulkKYCsImportHistory]: '/manual-bulk-kycs-import-history',
  [ApiRouteTypes.PostManualBulkKYCsImportHistory]: '/manual-bulk-kycs-import-history',
  [ApiRouteTypes.GetConsumersManualBulkKYCsImportHistoryPivot]: '/consumers-manual-bulk-kycs-import-history-pivot',
  [ApiRouteTypes.GetMerchantDomains]: '/merchant-domains',
  [ApiRouteTypes.PostMerchantDomains]: (coreId?: ID) => route(['merchant-domains', coreId]),
  [ApiRouteTypes.DeleteMerchantDomains]: (coreId: ID) => route(['merchant-domains', coreId]),
  [ApiRouteTypes.GetMerchantBusinesses]: (coreId?: ID) => route(['merchant-businesses', coreId]),
  [ApiRouteTypes.PostMerchantBusinesses]: (coreId?: ID) => route(['merchant-businesses', coreId]),
  [ApiRouteTypes.DeleteMerchantBusinesses]: (coreId: ID) => route(['merchant-businesses', coreId]),
  [ApiRouteTypes.GetBitsoBanks]: '/bitso-banks',
  [ApiRouteTypes.PostVerify2FA]: '/verify',
  [ApiRouteTypes.PostResend2FACode]: '/resend-2fa-code',
  [ApiRouteTypes.PostRecover]: '/recover',
  [ApiRouteTypes.PostNewPassword]: '/new-password',
  [ApiRouteTypes.GetImportConsumerBlacklist]: '/import-consumer-blacklist',
  [ApiRouteTypes.PostImportConsumerBlacklist]: '/import-consumer-blacklist',
  [ApiRouteTypes.PostImportConsumerWhitelist]: '/import-consumer-whitelist',
  [ApiRouteTypes.GetTemplateEmailsWhitelist]: route(['template-emails-whitelist']),
  [ApiRouteTypes.GetTemplateEmailsWhitelistWithoutSdd]: route(['template-emails-whitelist-without-sdd']),
  [ApiRouteTypes.GetBankingSdkConnectors]: '/banking-sdk-connectors',
  [ApiRouteTypes.GetIbanXsBanks]: '/iban-xs-banks',
  [ApiRouteTypes.GetSetups]: (identifier?: ID) => route(['setups', identifier]),
  [ApiRouteTypes.PutSetups]: (coreId?: ID) => route(['setups', coreId]),
  [ApiRouteTypes.DeleteSetup]: (coreId: ID) => route(['setups', coreId]),
  [ApiRouteTypes.PostSetupGroupPivot]: (coreId?: ID) => route(['setups-groups-pivot', coreId]),
  [ApiRouteTypes.PutBankingSdkConnectors]: (coreId?: ID) =>
    route(['banking-sdk-connectors', coreId]),
  [ApiRouteTypes.PutIbanXsBanks]: (coreId?: ID) =>
    route(['iban-xs-banks', coreId]),
  [ApiRouteTypes.GetBankingSdkRecipients]: '/banking-sdk-recipients',
  [ApiRouteTypes.PostBankingSdkRecipients]: '/banking-sdk-recipients',
  [ApiRouteTypes.PutBankingSdkRecipients]: (coreId?: ID) =>
    route(['banking-sdk-recipients', coreId]),
  [ApiRouteTypes.DeleteBankingSdkRecipients]: (coreId: ID) =>
    route(['banking-sdk-recipients', coreId]),
  [ApiRouteTypes.GetBankingSdkConnectorsRecipientsPivot]: '/banking-sdk-connectors-recipients-pivot',
  [ApiRouteTypes.PostBankingSdkConnectorsRecipientsPivot]: '/banking-sdk-connectors-recipients-pivot',
  [ApiRouteTypes.PutBankingSdkConnectorsRecipientsPivot]: (coreId?: ID) =>
    route(['banking-sdk-connectors-recipients-pivot', coreId]),
  [ApiRouteTypes.DeleteBankingSdkConnectorsRecipientsPivot]: (coreId: ID) =>
    route(['banking-sdk-connectors-recipients-pivot', coreId]),
  [ApiRouteTypes.GetIbanXsBanksRecipientsPivot]: '/iban-xs-banks-recipients-pivot',
  [ApiRouteTypes.PostIbanXsBanksRecipientsPivot]: '/iban-xs-banks-recipients-pivot',
  [ApiRouteTypes.PutIbanXsBanksRecipientsPivot]: (coreId?: ID) =>
    route(['iban-xs-banks-recipients-pivot', coreId]),
  [ApiRouteTypes.DeleteIbanXsBanksRecipientsPivot]: (coreId: ID) =>
    route(['iban-xs-banks-recipients-pivot', coreId]),
  [ApiRouteTypes.GetIbanXsBanksCountriesPivot]: '/iban-xs-banks-countries-pivot',
  [ApiRouteTypes.PostIbanXsBanksCountriesPivot]: '/iban-xs-banks-countries-pivot',
  [ApiRouteTypes.PutIbanXsBanksCountriesPivot]: (coreId?: ID) =>
    route(['iban-xs-banks-countries-pivot', coreId]),
  [ApiRouteTypes.DeleteIbanXsBanksCountriesPivot]: (coreId: ID) =>
    route(['iban-xs-banks-countries-pivot', coreId]),
  [ApiRouteTypes.GetTransactionsOpXHeadersHistory]: '/transactions-op-x-headers-history',
  [ApiRouteTypes.GetApplications]: (userId?: ID) => route(['applications', userId]),
  [ApiRouteTypes.PutApplications]: (userId: ID) => route(['applications', userId]),
  [ApiRouteTypes.PatchApplications]: (userId: ID) => route(['applications', userId]),
  [ApiRouteTypes.DeleteApplications]: (userId: ID) => route(['applications', userId]),
  [ApiRouteTypes.GetECommerceBusinessInformationSteps]: (userId: ID) => route(['business-information-steps', userId]),
  [ApiRouteTypes.PutECommerceBusinessInformationSteps]: (userId: ID) => route(['business-information-steps', userId]),
  [ApiRouteTypes.GetECommerceBillingFinanceSteps]: (userId: ID) => route(['billing-finance-steps', userId]),
  [ApiRouteTypes.PutECommerceBillingFinanceSteps]: (userId: ID) => route(['billing-finance-steps', userId]),
  [ApiRouteTypes.GetECommerceMediaComplianceSteps]: (userId: ID) => route(['media-compliance-steps', userId]),
  [ApiRouteTypes.PutECommerceMediaComplianceSteps]: (userId: ID) => route(['media-compliance-steps', userId]),
  [ApiRouteTypes.GetECommerceIdentityVerificationSteps]: (userId: ID) => route(['identity-verification-steps', userId]),
  [ApiRouteTypes.PutECommerceIdentityVerificationSteps]: (userId: ID) => route(['identity-verification-steps', userId]),
  [ApiRouteTypes.GetECommercePaymentMethodsSteps]: (userId: ID) => route(['payment-methods-steps', userId]),
  [ApiRouteTypes.PutECommercePaymentMethodsSteps]: (userId: ID) => route(['payment-methods-steps', userId]),
  [ApiRouteTypes.PutECommerceUboIdentities]: (uboIdentity?: ID) => route(['ubo-identities', uboIdentity]),
  [ApiRouteTypes.PostPspSettlements]: '/psp-settlements',
  [ApiRouteTypes.GetOnboardingLogs]: (userId?: ID) => route(['onboardings-logs', userId]),
  [ApiRouteTypes.GetWaMessages]: '/wa-messages',
  [ApiRouteTypes.GetWaMessagesSetups]: '/wa-messages-setups',
  [ApiRouteTypes.PostWaMessagesSetups]: '/wa-messages-setups',
  [ApiRouteTypes.PutWaMessagesSetups]: (coreId?: ID) =>
    route(['wa-messages-setups', coreId]),
  [ApiRouteTypes.DeleteWaMessagesSetups]: (coreId: ID) =>
    route(['wa-messages-setups', coreId]),
  [ApiRouteTypes.GetPhoneVerifications]: '/phone-verifications',
  [ApiRouteTypes.GetFailedPhoneVerifications]: '/failed-phone-verifications',
  [ApiRouteTypes.GetWaTemplatesSetups]: '/wa-templates-setups',
  [ApiRouteTypes.PostWaTemplatesSetups]: '/wa-templates-setups',
  [ApiRouteTypes.PutWaTemplatesSetups]: (coreId?: ID) =>
    route(['wa-templates-setups', coreId]),
  [ApiRouteTypes.DeleteWaTemplatesSetups]: (coreId: ID) =>
    route(['wa-templates-setups', coreId]),
};
